import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PageUrls } from 'src/app/helpers/page-urls';
import { AppUtils } from 'src/app/helpers/app.utils';
import { UserService } from 'src/app/admin/services/user.service';
import { TableModel } from 'src/app/models/table.model';
import { PagedContributorDetailModel } from 'src/app/admin/models/paged.contributor.detail.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-user-pending-contributor',
    templateUrl: './user-pending.contributor.component.html',
    styleUrls: ['./user-pending.contributor.component.scss']
})
export class UserPendingContributorComponent implements OnInit, OnDestroy {
    tableModel = new TableModel();
    totalRecords = 1;
    subscriptions = new Array<Subscription>();
    pagedContributorDetail = new PagedContributorDetailModel();
    isModelLoaded = false;

    constructor(private router: Router, private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private userService: UserService) {
        this.tableModel.orderBy = 'User.FirstName';
        this.tableModel.orderByDirection = 'asc';
    }

    get urls() {
        return PageUrls;
    }

    ngOnInit() {
        this.initSubscribers();
        this.getPendingPhotographers();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getPendingPhotographers());
        this.subscriptions.push(subscription);
    }

    getPendingPhotographers() {
        this.isModelLoaded = false;
        this.ngxSpinner.show();
        this.userService.listPendingContributor(this.tableModel)
            .subscribe(data => {
                this.pagedContributorDetail = data;
                this.totalRecords = data.totalCount;
                this.ngxSpinner.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    approveContributor(id: number) {
        this.ngxSpinner.show();
        this.userService.approveContributor(id)
            .subscribe(() => {
                this.toastr.success('Photographer has been approved successfully');
                this.ngxSpinner.hide();
                this.getPendingPhotographers();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    deleteContributor(id: number) {
        if (!confirm('Are you sure you want to delete this photographer?')) {
            return;
        }
        this.ngxSpinner.show();
        this.userService.deletePendingContributor(id)
            .subscribe(() => {
                this.toastr.success('Photographer has been deleted successfully');
                this.ngxSpinner.hide();
                this.getPendingPhotographers();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
